import GifCard from './GifCard';
import ImageCard from './ImageCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ImageAttachmentCard = ({
  fileMetadata,
  onPress
}) => {
  return fileMetadata.extension === 'gif' ? /*#__PURE__*/_jsx(GifCard, {
    fileMetadata: fileMetadata,
    onPress: onPress
  }) : /*#__PURE__*/_jsx(ImageCard, {
    fileMetadata: fileMetadata,
    onPress: onPress
  });
};
ImageAttachmentCard.displayName = 'ImageAttachmentCard';
export default ImageAttachmentCard;